// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__tS2St","sendOtp":"AuthorizeToLogin_sendOtp__1d3nh"};